export const ITEM_THUMBNAIL_DEFAULT_URL =
  'https://ik.imagekit.io/landing/webAssets/item-thumbnail-default_b19KIiQIM.png';
